import axios from "axios";

export interface KnownPatientLastAppointment {
  date: string;
  doctorFirstName?: string | null;
  doctorLastName?: string | null;
  doctorProviderSuffix?: string | null;
  officeId?: string | null;
}

export interface KnownPatient {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  dateOfBirth: string;
  smsOptInNotices: boolean;
  smsOptInPromos: boolean;
  lastAppointment?: KnownPatientLastAppointment | null;
}

interface KnownPatientAPIResponse {
  id: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  email: string;
  date_of_birth: string;
  sms_opt_in_notices: boolean;
  sms_opt_in_promos: boolean;
}

const mapKnownPatient = (data: KnownPatientAPIResponse): KnownPatient => ({
  id: data.id,
  firstName: data.first_name,
  lastName: data.last_name,
  phoneNumber: data.phone_number,
  email: data.email,
  dateOfBirth: data.date_of_birth,
  smsOptInNotices: data.sms_opt_in_notices,
  smsOptInPromos: data.sms_opt_in_promos,
});

export const getKnownPatientRequest =
  async (): Promise<KnownPatient | null> => {
    const response = await axios.get<KnownPatientAPIResponse>(
      "/api/v2/known_patient",
      {
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
        validateStatus: (status) => status === 200 || status === 204,
      }
    );

    if (response.status === 204) return null;

    return mapKnownPatient(response.data);
  };
